(() => {
  if (customElements.get('canvoil-event-clock')) return;
  class CanvoilEventClock extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      this.end = Date.parse(this.dataset.end);
      this.banner = this.closest('.canvoil-event-banner');
      if (!Number.isFinite(this.end)) {
        this.hidden = true;
        return;
      }
      this.days = this.querySelector('[data-days]');
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      if (this.update()) this.timer = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
      if (remaining === 0) {
        clearInterval(this.timer);
        this.hidden = true;
        if (this.banner) this.banner.hidden = true;
        return false;
      }
      const pad = n => String(n).padStart(2, '0');
      this.days.textContent = pad(Math.floor(remaining / 86400));
      this.hours.textContent = pad(Math.floor(remaining / 3600) % 24);
      this.minutes.textContent = pad(Math.floor(remaining / 60) % 60);
      this.seconds.textContent = pad(remaining % 60);
      this.hidden = false;
      if (this.banner) this.banner.hidden = false;
      return true;
    }
  }
  customElements.define('canvoil-event-clock', CanvoilEventClock);
})();
